import store from '../../../store';

export default async (to, from, next) => {
  const isPublic = (to.matched && to.matched.some(r => r.meta && r.meta.public))
    || to.name === 'login'
    || to.name === 'recuperar'
    || to.name === 'recoverView';

  if (isPublic) return next();

  const token = sessionStorage.token;
  if (!token) {
    await store.dispatch('Auth/logout');
    return next({ name: 'login' });
  }

  // Bloquear navegación hasta que cambie la contraseña
  const mustChange = sessionStorage.getItem('must_change_password') === 'true';
  if (mustChange && to.name !== 'changePassword') {
    return next({ name: 'changePassword' });
  }

  const allowedRoles = (to.meta && Array.isArray(to.meta.roles) && to.meta.roles.length > 0)
    ? to.meta.roles
    : null;

  // Principio de denegación por defecto:
  // si la ruta no tiene roles definidos explícitamente, se deniega el acceso.
  if (!allowedRoles) {
    console.warn(`[ROUTER] Ruta "${to.path}" sin roles definidos — acceso denegado por defecto`);
    return next({ name: 'login' });
  }

  const role = store.getters['Auth/role'];
  if (allowedRoles.includes(role)) return next();

  await store.dispatch('Auth/logout');
  return next({ name: 'login' });
};
